/* Accumulation — quiet WebGL field for the Program page.
   No silhouette, no focal object: a depth field that densifies as the page
   scrolls, dimmed through the centre column so the copy always leads. */
(function () {
  var canvas = document.querySelector('[data-program-backdrop]');
  if (!canvas) return;

  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var gl;
  try {
    gl = canvas.getContext('webgl', { antialias: true, alpha: true, powerPreference: 'high-performance' })
      || canvas.getContext('experimental-webgl', { antialias: true, alpha: true });
  } catch (e) { return; }
  if (!gl) return;

  var mobile = innerWidth < 900;
  var COUNT = mobile ? 300 : 560;

  // Pages with their own hero animation can hold the field back until the
  // hero is behind you, so the two never compete.
  var FADE_START = parseFloat(canvas.getAttribute('data-fade-start') || '0') || 0;
  var FADE_SPAN = 0.12;

  var pos = new Float32Array(COUNT * 3);
  var seeds = new Float32Array(COUNT);
  var order = new Float32Array(COUNT);   // when this point joins the field
  var amber = new Float32Array(COUNT);

  // A narrow screen is all "centre column", so mobile keeps the field closer in
  // and leans on low opacity rather than on edge-biasing to stay behind the copy.
  var INNER = mobile ? 0.04 : 0.30;
  var SPREAD_X = mobile ? 15 : 26;

  for (var i = 0; i < COUNT; i++) {
    var side = Math.random() < 0.5 ? -1 : 1;
    var lateral = INNER + Math.pow(Math.random(), 0.7) * 0.95;
    pos[i * 3] = side * lateral * SPREAD_X;
    pos[i * 3 + 1] = (Math.random() * 2 - 1) * 20;
    pos[i * 3 + 2] = (Math.random() * 2 - 1) * 20;
    seeds[i] = Math.random();
    order[i] = Math.random();
    amber[i] = (i % 14 === 0) ? 1 : 0;
  }

  // ---- matrices (column-major) ----------------------------------------
  function perspective(fovy, aspect, near, far) {
    var f = 1 / Math.tan(fovy / 2), nf = 1 / (near - far);
    return new Float32Array([
      f / aspect, 0, 0, 0,
      0, f, 0, 0,
      0, 0, (far + near) * nf, -1,
      0, 0, 2 * far * near * nf, 0
    ]);
  }

  var vert = [
    'attribute vec3 aPos;',
    'attribute float aSeed;',
    'attribute float aOrder;',
    'attribute float aAmber;',
    'uniform mat4 uProjection;',
    'uniform float uProgress;',
    'uniform float uTime;',
    'uniform float uPixelRatio;',
    'uniform float uSizeScale;',
    'uniform float uDrift;',
    'uniform float uCentreFloor;',
    'uniform float uMaxAlpha;',
    'varying float vAlpha;',
    'varying float vAmber;',
    'void main(){',
    // The field fills in as the page advances — never empty, never crowded.
    '  float joined = smoothstep(aOrder * 0.88 - 0.12, aOrder * 0.88 + 0.12, uProgress);',
    '  float presence = 0.26 + joined * 0.74;',
    '  vec3 p = aPos;',
    '  p.y += uDrift;',
    '  p.x += sin(uTime * 0.19 + aSeed * 6.28) * 1.5;',
    '  p.y += cos(uTime * 0.15 + aSeed * 5.11) * 1.5;',
    '  p.z += sin(uTime * 0.13 + aSeed * 4.63) * 1.2;',
    '  vec4 mv = vec4(p.x, p.y, p.z - 34.0, 1.0);',
    '  gl_Position = uProjection * mv;',
    '  float dist = max(-mv.z, 0.001);',
    '  gl_PointSize = (120.0 / dist) * uPixelRatio * uSizeScale * (1.0 + aAmber * 0.55);',
    // Fade through the middle of the screen, where the copy lives.
    '  float ndcX = abs(gl_Position.x / max(gl_Position.w, 0.001));',
    '  float edge = uCentreFloor + smoothstep(0.10, 0.85, ndcX) * (1.0 - uCentreFloor);',
    '  vAlpha = smoothstep(58.0, 12.0, dist) * presence * edge * uMaxAlpha;',
    '  vAmber = aAmber;',
    '}'
  ].join('\n');

  var frag = [
    'precision mediump float;',
    'uniform vec3 uAmber;',
    'uniform vec3 uOff;',
    'varying float vAlpha;',
    'varying float vAmber;',
    'void main(){',
    '  vec2 c = gl_PointCoord - vec2(0.5);',
    '  float d = length(c);',
    '  if (d > 0.5) discard;',
    '  float core = smoothstep(0.5, 0.0, d);',
    '  vec3 col = mix(uOff, uAmber, vAmber);',
    '  gl_FragColor = vec4(col, core * vAlpha * mix(0.30, 0.78, vAmber));',
    '}'
  ].join('\n');

  function compile(type, src) {
    var sh = gl.createShader(type);
    gl.shaderSource(sh, src);
    gl.compileShader(sh);
    if (!gl.getShaderParameter(sh, gl.COMPILE_STATUS)) { gl.deleteShader(sh); return null; }
    return sh;
  }

  var vs = compile(gl.VERTEX_SHADER, vert);
  var fs = compile(gl.FRAGMENT_SHADER, frag);
  if (!vs || !fs) return;

  var program = gl.createProgram();
  gl.attachShader(program, vs);
  gl.attachShader(program, fs);
  gl.linkProgram(program);
  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return;

  canvas.style.opacity = '1';

  function buffer(data) {
    var b = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, b);
    gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);
    return b;
  }

  var bPos = buffer(pos), bSeed = buffer(seeds), bOrder = buffer(order), bAmber = buffer(amber);

  var aPos = gl.getAttribLocation(program, 'aPos');
  var aSeed = gl.getAttribLocation(program, 'aSeed');
  var aOrder = gl.getAttribLocation(program, 'aOrder');
  var aAmber = gl.getAttribLocation(program, 'aAmber');
  var uProjection = gl.getUniformLocation(program, 'uProjection');
  var uProgress = gl.getUniformLocation(program, 'uProgress');
  var uTime = gl.getUniformLocation(program, 'uTime');
  var uPixelRatio = gl.getUniformLocation(program, 'uPixelRatio');
  var uSizeScale = gl.getUniformLocation(program, 'uSizeScale');
  var uDrift = gl.getUniformLocation(program, 'uDrift');
  var uCentreFloor = gl.getUniformLocation(program, 'uCentreFloor');
  var uMaxAlpha = gl.getUniformLocation(program, 'uMaxAlpha');
  var uAmberCol = gl.getUniformLocation(program, 'uAmber');
  var uOff = gl.getUniformLocation(program, 'uOff');

  function bind(loc, buf, size) {
    if (loc < 0) return;
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, size, gl.FLOAT, false, 0, 0);
  }

  gl.enable(gl.BLEND);
  gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
  gl.disable(gl.DEPTH_TEST);
  gl.useProgram(program);

  var DPR = Math.min(devicePixelRatio || 1, mobile ? 1.75 : 2);
  var SIZE_SCALE = mobile ? 1.1 : 1;
  // Mobile can't rely on edge-biasing, so the centre stays lit but overall alpha drops.
  var CENTRE_FLOOR = mobile ? 0.68 : 0.26;
  var MAX_ALPHA = mobile ? 0.70 : 1.0;
  var FOV = 56 * Math.PI / 180;
  var projection = perspective(FOV, 1, 0.1, 240);

  function resize() {
    var w = canvas.clientWidth, h = canvas.clientHeight;
    if (!w || !h) return;
    canvas.width = Math.round(w * DPR);
    canvas.height = Math.round(h * DPR);
    gl.viewport(0, 0, canvas.width, canvas.height);
    projection = perspective(FOV, w / h, 0.1, 240);
  }
  addEventListener('resize', resize);
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(resize).observe(canvas);
  } else {
    addEventListener('load', resize);
    requestAnimationFrame(resize);
  }
  resize();

  var progress = 0, targetProgress = 0;
  function onScroll() {
    var max = document.documentElement.scrollHeight - innerHeight;
    targetProgress = max > 0 ? Math.max(0, Math.min(1, (window.scrollY || document.documentElement.scrollTop) / max)) : 0;
  }
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  progress = targetProgress;

  var hidden = false;
  document.addEventListener('visibilitychange', function () { hidden = document.hidden; });

  var start = performance.now();

  function frame(now) {
    requestAnimationFrame(frame);
    if (hidden) return;

    var t = (now - start) / 1000;
    progress += (targetProgress - progress) * 0.07;

    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.uniformMatrix4fv(uProjection, false, projection);
    gl.uniform1f(uProgress, progress);
    gl.uniform1f(uTime, t);
    gl.uniform1f(uPixelRatio, DPR);
    gl.uniform1f(uSizeScale, SIZE_SCALE);
    gl.uniform1f(uDrift, -progress * 7.0);      // gentle parallax as the page moves
    gl.uniform1f(uCentreFloor, CENTRE_FLOOR);
    var intro = FADE_START > 0
      ? Math.max(0, Math.min(1, (progress - FADE_START) / FADE_SPAN))
      : 1;
    gl.uniform1f(uMaxAlpha, MAX_ALPHA * intro);
    gl.uniform3f(uAmberCol, 0.898, 0.651, 0.231);
    gl.uniform3f(uOff, 0.957, 0.957, 0.957);

    bind(aPos, bPos, 3);
    bind(aSeed, bSeed, 1);
    bind(aOrder, bOrder, 1);
    bind(aAmber, bAmber, 1);
    gl.drawArrays(gl.POINTS, 0, COUNT);
  }
  requestAnimationFrame(frame);
})();
